import type {TMinorActionDataAcceptForcedDeal} from '@kapitalist/contract/types'
import {skins} from '~/game/skins'
import Card from '~/models/game/Card'
import {propertyCardFactory} from '~/models/game/factories'
import {PlayerGamePosition} from '~/models/game/GamePosition'
import type {TMinorActionUserFacingDescriptionData} from '~/models/game/MinorAction'
import MinorAction from '~/models/game/MinorAction'
import type {AnyPropertyCard} from '~/models/game/types'
import {mutateIf} from '~/utils/etc'
import {sentenceCase, xVerbY} from '~/utils/language'

export default class MinorActionAcceptForcedDeal extends MinorAction<TMinorActionDataAcceptForcedDeal> {
  requestedCard: AnyPropertyCard
  offeredCard: AnyPropertyCard

  constructor(data: TMinorActionDataAcceptForcedDeal) {
    super(data)
    this.requestedCard = propertyCardFactory(data.requestedCard)
    this.offeredCard = propertyCardFactory(data.offeredCard)
  }

  userFacingDescription({
    tense,
    majorActor,
    minorActor,
    skin,
    gamePosition,
  }: TMinorActionUserFacingDescriptionData): string {
    const currentPlayer =
      gamePosition instanceof PlayerGamePosition
        ? gamePosition.currentPlayer
        : undefined

    const dropFirstNoun = tense === 'imperativePrompt'

    const {conjugatedVerb, xNoun, yNounPossessive} = xVerbY(
      tense,
      minorActor,
      dropFirstNoun ? 'Accept' : 'accept',
      majorActor,
      currentPlayer?.id
    )

    return skins[skin].gameLogDescriptions.minorActionResponses.acceptForcedDeal({
      tense,
      actor: dropFirstNoun
        ? undefined
        : xNoun === minorActor.username
          ? xNoun
          : sentenceCase(xNoun),
      verb: mutateIf(conjugatedVerb, dropFirstNoun, sentenceCase),
      targetPossessive: yNounPossessive,
      cardName: Card.displayNameForCard('forcedDeal', skin),
    })
  }
}
